<template>
  <div>
    <div v-for="teacher in assignedTeachers" :key="teacher.id" class="my-3">
      <div class="d-flex" v-if="!endTeacher || endTeacher.id != teacher.id">
        <div>
          <div>
            {{ teacher.firstName }}
            {{ teacher.lastName }}
          </div>
          <div class="text-caption">
            <div>
              <v-icon small class="mr-2">mdi-email-outline</v-icon
              >{{ teacher.email }}
            </div>
            <div>
              <v-icon small class="mr-2">mdi-phone-outline</v-icon>
              <the-mask mask="+1(###) ###-####" v-model="teacher.phone" />
            </div>
            <div>
              <v-icon small class="mr-2">mdi-calendar-end</v-icon>
              <span v-if="getTeacherEndDate(teacher)"
                >Last day - {{ getTeacherEndDate(teacher) | formatDate }}</span
              >
              <span v-else>No end date</span>
            </div>
          </div>
        </div>
        <div class="ml-5" v-if="showMenu">
          <v-menu>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon> mdi-dots-vertical </v-icon>
              </v-btn>
            </template>
            <v-card class="mx-auto" max-width="400" width="250" tile>
              <v-list dense>
                <v-list-item-group color="primary">
                  <v-list-item @click="endTeacherSchedule(teacher)">
                    <v-list-item-icon class="mr-2">
                      <v-icon>mdi-calendar-end</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>End Schedule</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    :to="{
                      name: 'SubstituteTeacher',
                      params: {
                        courseId: courseSchedule.course.id,
                        scheduleId: courseSchedule.id,
                        teacherId: teacher.id,
                        date: scheduleDate,
                      },
                    }"
                  >
                    <v-list-item-icon class="mr-2">
                      <v-icon>mdi-account-switch</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Substitute Teacher</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-menu>
        </div>
      </div>
      <div v-else>
        <v-text-field
          v-model="teacherScheduleEndDate"
          type="date"
          label="Enter the last day for this teacher"
        />
        <v-btn @click="saveEndTeacherSchedule" small>End Schedule</v-btn>
        <v-btn class="ml-0 ml-5 mt-2 mt-lg-0" small @click="endTeacher = null"
          >Cancel</v-btn
        >
      </div>
    </div>

    <div class="my-2" v-if="assignedTeachers.length < 1">
      <v-alert
        v-if="assignedTeachers.length < 1"
        type="warning"
        border="left"
        colored-border
        >No teacher is assigned to this schedule, please use the form below to
        assign a teacher.
      </v-alert>

      <assign-teacher
        :scheduleId="courseSchedule.id"
        :scheduleDate="courseScheduleDate"
        :recurring="courseSchedule.rrule != null"
        @assignedTeacher="assignedTeacher"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
const AssignTeacher = () => import("./AssignTeacher.vue");
import { TheMask } from "vue-the-mask";

export default {
  props: {
    courseSchedule: {
      type: Object,
      required: false,
    },
    scheduleDate: {
      type: [String, Date, null],
      required: false,
    },
    showMenu:{
            type: Boolean,
            required: false,
            default: true
        },
  },
  computed: {
    courseScheduleDate() {
      if (this.scheduleDate) {
        return this.scheduleDate;
      } else if (!this.scheduleDate && this.courseSchedule.rrule != null) {
        return this.courseSchedule.startDate;
      } else {
        return null;
      }
    },
  },
  data: () => {
    return {
      endTeacher: null,
      assignedTeachers: [],
      teacherScheduleEndDate: null,
    };
  },
  components: {
    AssignTeacher,
    TheMask,
  },
  mounted() {
    this.initAssignedTeachers();
    // console.log('teacher course schedule: ', this.courseSchedule)
  },
  methods: {
    ...mapActions(["addErrorMessage", "addSuccessMessage", "clearMessage"]),
    getTeacherEndDate(teacher) {
      if (!teacher) {
        return null;
      }

      let teacherSchedule = null;
      if(this.courseSchedule.teacherSchedules){
       teacherSchedule = this.courseSchedule.teacherSchedules.filter(
          (ts) => ts.teacherId == teacher.id
        );
      }
      if (teacherSchedule && teacherSchedule.length > 0) {
        return teacherSchedule[0].endDate;
      } else {
        return null;
      }
    },
    async initAssignedTeachers() {
      let teachers = [];
      let teacherSchedule = [];

      const params = {
        course_schedule_id: this.courseSchedule.id,
        schedule_date: this.scheduleDate ? moment(this.scheduleDate).format('YYYY-MM-DD'):null,
      }
      // fetch from server
      await this.$axios.get('/teacher-schedule/find-course-assigned', {params})
        .then( resp => {
          teacherSchedule = resp.data;
        })

      //Filter teacher scheduled for the schedule date, if provided
      // if (this.scheduleDate) {
      //   const date = moment(this.scheduleDate).format("YYYY-MM-DD");
      //   teacherSchedule = this.courseSchedule.teacherSchedules.filter((ts) => {
      //     return ts.scheduledDates.includes(date);
      //   });
      // } else {
      //   teacherSchedule = this.courseSchedule.teacherSchedules;
      // }

      if (teacherSchedule && teacherSchedule.length > 0) {
        teacherSchedule.forEach((ts) => {
          const teacher = this.courseSchedule.teachers.find(
            (t) => t && ts && t.id == ts.teacherId
          );
          if (teacher) {
            teachers.push(teacher);
          }
        });
      }

      this.assignedTeachers = teachers;
    },
    assignedTeacher(teacherSchedule) {
      if (this.courseSchedule.teacherSchedules) {
        this.courseSchedule.teacherSchedules.push(teacherSchedule);
      } else {
        this.courseSchedule.teacherSchedules = [teacherSchedule];
      }
      const teacher = teacherSchedule.teacher;

      if (this.assignedTeachers) {
        this.assignedTeachers.push(teacher);
      } else {
        this.assignedTeachers = [teacher];
      }
    },
    endTeacherSchedule(teacher) {
      this.endTeacher = teacher;
      this.teacherScheduleEndDate = moment(this.scheduleDate).format(
        "YYYY-MM-DD"
      );
    },
    saveEndTeacherSchedule() {
      if (this.endTeacher && this.teacherScheduleEndDate) {
        const data = {
          courseScheduleId: this.courseSchedule.id,
          date: this.teacherScheduleEndDate,
          originalTeacherId: this.endTeacher.id,
        };
        this.$axios
          .post("/course-schedule/end-teacher-schedule", data)
          .then((resp) => {
            this.addSuccessMessage(
              `Ended schedule for ${this.endTeacher.firstName}`
            );

            const schedule = resp.data.data;
            this.courseSchedule.teacherSchedules = schedule.teacherSchedules;
            this.endTeacher = null;
            this.teacherScheduleEndDate = null;
            this.initAssignedTeachers();
          })
          .catch((error) => {
            this.addErrorMessage(
              error.data.message || "Error ending teachers schedule"
            );
          });
      } else {
        this.addErrorMessage("An end date is required");
      }
    },
  },
};
</script>

<style>
</style>